/* Violet Serra Boutique — Halloween 2026 nella pagina prodotto.
   Zucche qua e là, un volo di pipistrelli all'arrivo, un ragnetto nelle FAQ e le scintille nel finale.
   Solo decorazioni: niente clic rubati, niente spostamenti del layout. Si spegne da sola il 1° novembre. */
(function () {
  'use strict';
  var C = window.LDT_HW || {}, T = C.t || {};
  if (!C.end || Date.now() >= new Date(C.end).getTime()) return;
  if (window.Shopify && window.Shopify.designMode) return;

  var doc = document, html = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var small = window.matchMedia('(max-width: 749px)').matches;
  function $(s, r) { return (r || doc).querySelector(s); }
  function add(parent, markup) { parent.insertAdjacentHTML('beforeend', markup); return parent.lastElementChild; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function whenSeen(el, fn, th) {
    if (!('IntersectionObserver' in window)) return fn();
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { io.disconnect(); fn(); } });
    }, { threshold: th || 0.2 });
    io.observe(el);
  }

  html.classList.add('ldt-hw');

  /* ---------- disegni ---------- */
  doc.body.insertAdjacentHTML('afterbegin',
    '<svg class="hw-defs" aria-hidden="true" focusable="false"><defs>' +
    '<radialGradient id="hwPkO" cx="35%" cy="30%" r="80%"><stop offset="0" stop-color="#f7a24a"/><stop offset=".55" stop-color="#dc6a20"/><stop offset="1" stop-color="#a5430f"/></radialGradient>' +
    '<radialGradient id="hwPkM" cx="38%" cy="28%" r="78%"><stop offset="0" stop-color="#fbb45d"/><stop offset=".55" stop-color="#e77a2b"/><stop offset="1" stop-color="#b8521a"/></radialGradient>' +
    '<radialGradient id="hwPkC" cx="42%" cy="26%" r="75%"><stop offset="0" stop-color="#ffc370"/><stop offset=".55" stop-color="#f08d37"/><stop offset="1" stop-color="#c65d1e"/></radialGradient>' +
    '<linearGradient id="hwPkS" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#8a7246"/><stop offset="1" stop-color="#4a3a1f"/></linearGradient>' +
    '</defs></svg>');
  var PK = '<ellipse class="hw-pk__sh" cx="60" cy="106" rx="42" ry="5"/>' +
    '<ellipse cx="33" cy="68" rx="27" ry="35" fill="url(#hwPkO)"/><ellipse cx="87" cy="68" rx="27" ry="35" fill="url(#hwPkO)"/>' +
    '<ellipse cx="46" cy="67" rx="24" ry="38" fill="url(#hwPkM)"/><ellipse cx="74" cy="67" rx="24" ry="38" fill="url(#hwPkM)"/>' +
    '<ellipse cx="60" cy="66" rx="20" ry="39" fill="url(#hwPkC)"/>' +
    '<path class="hw-pk__rib" d="M47 31c-8 12-8 60 0 72M73 31c8 12 8 60 0 72M33 36c-12 14-12 50 0 64M87 36c12 14 12 50 0 64"/>' +
    '<ellipse cx="49" cy="47" rx="5" ry="11" fill="#fff" opacity=".22" transform="rotate(-14 49 47)"/>' +
    '<path d="M56 32c0-9 2-16 5-22 2-3 8-2 7 2-2 6-4 12-4 20z" fill="url(#hwPkS)"/>' +
    '<path class="hw-pk__curl" d="M64 22c7-6 15-5 16 1 1 5-5 7-7 3"/>' +
    '<g class="hw-pk__face"><path d="M39 60l9-11 7 11z"/><path d="M65 60l7-11 9 11z"/>' +
    '<path d="M36 72Q60 92 84 72Q78 75 72 75L69 80 65 75.5Q60 76 55 75.5L51 80 48 75Q42 75 36 72z"/></g>';
  function pumpkin(cls) { return '<svg class="hw-pk' + (cls ? ' ' + cls : '') + '" viewBox="0 0 120 112" aria-hidden="true" focusable="false">' + PK + '</svg>'; }
  var BAT = '<svg class="hw-bat" viewBox="0 0 64 30" aria-hidden="true" focusable="false">' +
    '<path class="hw-bat__w" d="M31 14C25 6 15 3 3 6c5 2 7 5 7 9 4-2 8-1 10 2 2-3 6-3 11-3z"/>' +
    '<path class="hw-bat__w" d="M33 14c6-8 16-11 28-8-5 2-7 5-7 9-4-2-8-1-10 2-2-3-6-3-11-3z"/>' +
    '<ellipse cx="32" cy="15" rx="4.2" ry="6.2"/><path d="M28.8 10.5l.9-4.5 2 3.2zM35.2 10.5l-.9-4.5-2 3.2z"/></svg>';
  var SPIDER = '<svg viewBox="0 0 40 36" aria-hidden="true" focusable="false"><g fill="none" stroke="#1c1816" stroke-width="1.6" stroke-linecap="round">' +
    '<path d="M14 15 5 8M14 18 3 17M14 21 5 27M15 24 9 33M26 15l9-7M26 18l11-1M26 21l9 6M25 24l6 9"/></g>' +
    '<ellipse cx="20" cy="20" rx="7" ry="8" fill="#1c1816"/><circle cx="20" cy="10.5" r="4.5" fill="#1c1816"/>' +
    '<circle cx="18.4" cy="10" r="1" fill="#e8d3a6"/><circle cx="21.6" cy="10" r="1" fill="#e8d3a6"/></svg>';

  /* ---------- messaggi (tutti veri: niente codici inventati) ---------- */
  var toastEl = add(doc.body, '<div class="bw-toast hw-toast" role="status" aria-live="polite"></div>');
  function toast(m) {
    toastEl.innerHTML = pumpkin() + '<span></span>';
    toastEl.lastChild.textContent = m;
    toastEl.classList.add('is-on');
    clearTimeout(toastEl._t);
    toastEl._t = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3800);
  }

  /* ---------- 1. galleria: sigillo e zucche sulla prima foto ---------- */
  var list = $('.product__media-list');
  if (list && list.firstElementChild) {
    var txt = esc(T.seal || 'HALLOWEEN · BLACK FRIDAY · ');
    var gal = add(list.firstElementChild,
      '<div class="hw-gal" aria-hidden="true">' +
      '<div class="hw-seal"><svg viewBox="0 0 120 120" focusable="false">' +
      '<defs><path id="hwSealP" d="M60 60m-45 0a45 45 0 1 1 90 0a45 45 0 1 1-90 0"/></defs>' +
      '<circle class="hw-seal__bg" cx="60" cy="60" r="58"/><circle class="hw-seal__ln" cx="60" cy="60" r="34"/>' +
      '<g class="hw-seal__ring"><text><textPath href="#hwSealP" textLength="279" lengthAdjust="spacing">' + txt + '</textPath></text></g>' +
      '<svg x="35" y="37" width="50" height="47" viewBox="0 0 120 112">' + PK + '</svg></svg></div>' +
      '<div class="hw-patch">' + pumpkin('hw-pk--lit hw-pk--big') + pumpkin('hw-pk--small') + '</div></div>');
    if (getComputedStyle(gal.parentNode).position === 'static') gal.parentNode.style.position = 'relative';
    /* se cambiando colore il tema porta in cima un'altra foto, le decorazioni la seguono */
    new MutationObserver(function () {
      var f = list.firstElementChild;
      if (f && gal.parentNode !== f) {
        f.appendChild(gal);
        if (getComputedStyle(f).position === 'static') f.style.position = 'relative';
      }
    }).observe(list, { childList: true });
  }

  /* ---------- 2. box dell'offerta: la zucca seduta sul bordo (dolcetto o scherzetto) ---------- */
  var offer = $('.bw-offer');
  if (offer) {
    var btn = add(offer, '<button type="button" class="hw-pk-btn" aria-label="' + esc(T.aria || 'Dolcetto o scherzetto?') + '">' + pumpkin() + '</button>');
    var k = 0;
    btn.addEventListener('click', function () {
      btn.classList.add('is-lit');
      btn.classList.remove('is-flicker'); void btn.offsetWidth; btn.classList.add('is-flicker');
      var msgs = T.m || [];
      if (msgs.length) toast(msgs[k++ % msgs.length]);
      batFrom(btn);
    });
    if (!reduce) whenSeen(offer, function () { setTimeout(function () { btn.classList.add('is-hop'); }, 1800); }, 0.6);
  }

  /* ---------- 3. FAQ: un ragnetto scende quando arrivi ---------- */
  var faq = $('.bw-faq');
  if (faq) {
    var sp = add(faq, '<div class="hw-spider" aria-hidden="true"><span class="hw-spider__th"></span>' + SPIDER + '</div>');
    whenSeen(faq, function () { sp.classList.add('is-down'); }, 0.25);
  }

  /* ---------- 4. finale: zucche accese e scintille ---------- */
  var fin = $('.bw-final');
  if (fin) {
    add(fin, '<div class="hw-fin" aria-hidden="true">' + pumpkin('hw-pk--lit hw-pk--big') + pumpkin('hw-pk--lit hw-pk--small') + '</div>');
    if (!reduce) embers(fin);
  }

  /* ---------- 5. pipistrelli: un solo volo, alla prima pagina prodotto della visita ---------- */
  var seen = false;
  try { seen = sessionStorage.getItem('ldt-hw-bats') === '1'; sessionStorage.setItem('ldt-hw-bats', '1'); } catch (e) { /* storage bloccato: volo comunque */ }
  if (!reduce && !seen) setTimeout(flock, 900);

  function flock() {
    var box = add(doc.body, '<div class="hw-bats" aria-hidden="true"></div>');
    for (var i = 0, n = small ? 3 : 5; i < n; i++) {
      var b = add(box, '<div class="hw-fly">' + BAT + '</div>');
      b.style.setProperty('--y', (7 + Math.random() * 24).toFixed(1) + 'vh');
      b.style.setProperty('--s', Math.round((small ? 22 : 28) + Math.random() * 14) + 'px');
      b.style.setProperty('--d', (3.2 + Math.random() * 1.4).toFixed(2) + 's');
      b.style.setProperty('--dl', (i * 0.22 + Math.random() * 0.2).toFixed(2) + 's');
    }
    setTimeout(function () { box.remove(); }, 7000);
  }

  function batFrom(el) {
    if (reduce) return;
    var r = el.getBoundingClientRect();
    var b = add(doc.body, '<div class="hw-pop" aria-hidden="true">' + BAT + '</div>');
    b.style.left = Math.round(r.left + r.width / 2) + 'px';
    b.style.top = Math.round(r.top + r.height * 0.35) + 'px';
    setTimeout(function () { b.remove(); }, 1800);
  }

  /* scintille: salgono per 14 secondi quando il finale è a schermo, poi si spengono (ripartono se ci torni) */
  function embers(sec) {
    var cv = doc.createElement('canvas');
    cv.className = 'hw-embers';
    cv.setAttribute('aria-hidden', 'true');
    sec.insertBefore(cv, $('.bw-wrap', sec) || sec.firstChild);
    var ctx = cv.getContext('2d');
    if (!ctx) return;
    var W = 0, H = 0, dpr = Math.min(2, window.devicePixelRatio || 1), parts = [], raf = 0, t0 = 0, on = false;
    function size() {
      var r = sec.getBoundingClientRect();
      W = r.width; H = r.height;
      cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr);
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    function spawn(p, anywhere) {
      p.x = Math.random() * W; p.y = anywhere ? Math.random() * H : H + 10;
      p.r = 0.8 + Math.random() * 2.2; p.vy = 0.25 + Math.random() * 0.7;
      p.sw = Math.random() * 6.28; p.ss = 0.008 + Math.random() * 0.02;
      p.hue = Math.random() < 0.7 ? 26 + Math.random() * 12 : 42 + Math.random() * 6;
      return p;
    }
    function frame(ts) {
      if (!t0) t0 = ts;
      var age = (ts - t0) / 1000;
      var fade = age > 14 ? Math.max(0, 1 - (age - 14) / 2) : Math.min(1, age / 1.2 + 0.05);
      ctx.clearRect(0, 0, W, H);
      ctx.globalCompositeOperation = 'lighter';
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        p.y -= p.vy; p.sw += p.ss; p.x += Math.sin(p.sw) * 0.35;
        if (p.y < -10) spawn(p, false);
        var a = fade * (0.25 + 0.75 * Math.max(0, Math.min(1, p.y / H)));
        var g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.r * 4);
        g.addColorStop(0, 'hsla(' + p.hue + ',100%,70%,' + a.toFixed(3) + ')');
        g.addColorStop(1, 'hsla(' + p.hue + ',100%,50%,0)');
        ctx.fillStyle = g;
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r * 4, 0, 6.283); ctx.fill();
      }
      if (on && age < 16) raf = requestAnimationFrame(frame);
      else { ctx.clearRect(0, 0, W, H); on = false; }
    }
    function start() {
      if (on) return;
      on = true; t0 = 0; size();
      if (!parts.length) for (var i = 0, n = small ? 22 : 44; i < n; i++) parts.push(spawn({}, true));
      raf = requestAnimationFrame(frame);
    }
    function stop() { on = false; cancelAnimationFrame(raf); }
    new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) start(); else stop(); });
    }, { threshold: 0.15 }).observe(sec);
    window.addEventListener('resize', function () { if (on) size(); });
  }
})();
